import React from "react";
import Button from "../../lib/ui/components/button/Button";
import { BodyText, Heading6 } from "../../lib/ui/components/typography/Typography";

/**
 * Shown when a job still needs setup: not_setup is true, or the job is
 * INCOMPLETE (no interview questions yet). Not for roles that are set up
 * but have no applicants.
 */
export default function RoleNotSetUpEmptyState({ onSetUp, className = "" }) {
    return (
        <div
            className={`flex flex-col items-center px-6 py-12 text-center ${className}`}
            data-cy="role-not-setup-empty"
        >
            <Heading6 className="!mb-0">This role isn’t set up yet.</Heading6>
            <BodyText className="mt-2 max-w-md">
                Add role details and interview questions to start reviewing applicants.
            </BodyText>
            <Button
                variant="primary"
                className="mt-4"
                onClick={onSetUp}
                data-cy="role-not-setup-cta"
            >
                Set up the role
            </Button>
        </div>
    );
}
